/** @typedef {{ type: string, username: string }} CodingProfileEntry */

export const CODING_PROFILE_TYPE_OPTIONS = [
  { value: 'leetcode', label: 'LeetCode' },
  { value: 'github', label: 'GitHub' },
  { value: 'codeforces', label: 'Codeforces' },
  { value: 'codechef', label: 'CodeChef' },
];

export const CODING_PROFILE_TYPE_TO_FIELD = {
  leetcode: 'leetcodeUsername',
  github: 'githubUsername',
  codeforces: 'codeforcesUsername',
  codechef: 'codechefUsername',
};

const ORDER = CODING_PROFILE_TYPE_OPTIONS.map((o) => o.value);

/**
 * Build ordered `codingProfiles` from flat API user fields (GET /users/me).
 * @returns {CodingProfileEntry[]}
 */
export function userApiToCodingProfiles(userData) {
  const out = [];
  for (const type of ORDER) {
    const field = CODING_PROFILE_TYPE_TO_FIELD[type];
    const username = (userData[field] ?? '').toString().trim();
    if (username) out.push({ type, username });
  }
  return out;
}

/**
 * Flatten `codingProfiles` for PUT /users/me (student payload).
 * @param {CodingProfileEntry[] | undefined} codingProfiles
 * @returns {{ githubUsername: string, leetcodeUsername: string, codeforcesUsername: string, codechefUsername: string }}
 */
export function codingProfilesToApiFields(codingProfiles) {
  const flat = {
    githubUsername: '',
    leetcodeUsername: '',
    codeforcesUsername: '',
    codechefUsername: '',
  };
  for (const p of codingProfiles || []) {
    const field = CODING_PROFILE_TYPE_TO_FIELD[p.type];
    if (field) flat[field] = (p.username ?? '').toString().trim();
  }
  return flat;
}

export function labelForCodingProfileType(type) {
  return CODING_PROFILE_TYPE_OPTIONS.find((o) => o.value === type)?.label ?? type;
}
